<template>
  <div class="legalPersonMainBox">
    <div class="legalPersonBox">
      <div class="legalPersonList">
        <div class="legalPersonListItem">
          <div class="name">{{format.lawName}}</div>
          <div class="avatar">
            <img src="../../../../assets/image/ic_bm_cy.png" alt />
          </div>
        </div>
        <div class="legalPersonListItem">
          <div class="legalPersonListTitle">证件类型</div>
          <div class="legalPersonData">{{format.lawCertificateType}}</div>
        </div>
        <div class="legalPersonListItem">
          <div class="legalPersonListTitle">证件号码</div>
          <div class="legalPersonData">{{format.lawCertificateCode}}</div>
        </div>
        <div class="legalPersonListItem">
          <div class="legalPersonListTitle">联系电话</div>
          <div class="legalPersonData">{{format.lawTel}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      format: {}
    };
  },
  created() {
    this.format = this.$route.query;
  }
};
</script>

<style lang="less" scoped>
.legalPersonMainBox {
  padding: 16px 12px;
  height: 100%;
  background: #FBFBFB;
  .legalPersonBox {
    border-radius: 3px;
    .legalPersonList {
      .legalPersonListItem::after {
        content: "";
        display: block;
        clear: both;
      }
      .legalPersonListItem:first-child {
        padding: 0 16px;
        margin-bottom: 16px;
        height: 68px;
        border: none;
      }
      .legalPersonListItem {
        padding: 0 16px;
        background: #ffffff;
        border-bottom: 1px solid #EEEEEE;
        .avatar {
          border-radius: 50%;
          float: left;
          margin-top: 16px;
          margin-left: 223px;
          > img {
            width: 36px;
            height: 36px;
          }
        }

        .name {
          float: left;
          font-size: 20px;
          line-height: 20px;
          margin-top: 23px;
          font-weight:500;
        }

        .legalPersonListTitle {
          width: 80px;
          font-size: 16px;
          line-height: 46px;
          color: #999;
          float: left;
        }

        .legalPersonData {
          font-size: 16px;
          float: right;
          line-height: 46px;
        }
      }
    }
  }
}
</style>
